import React from 'react';
import styles from './ComparisonPopup.module.scss';
import CategoryHeader from '../ui/CategoryHeader/CategoryHeader';

const comparisonData = {
  'Базові послуги': [
    { service: 'Початкова консультація', price: '2 000 грн', standard: true, plus: true, premium: true },
    { service: 'Підбір та формулювання класів МКТП', price: '1 000 грн', standard: true, plus: true, premium: true },
    { service: 'Подання заявки на ТМ “під ключ”', price: '5 000 грн', standard: true, plus: true, premium: true },
    { service: 'Аналіз ризиків на основі перевірки', price: '2 000 грн', standard: false, plus: true, premium: true },
  ],
  'Супровід та захист': [
    { service: 'Контроль статусу експертизи', price: '2 000 грн', standard: true, plus: true, premium: true },
    { service: 'Відповіді на формальні запити', price: '2 000 грн', standard: true, plus: true, premium: true },
    { service: 'Консультування щодо порушень прав', price: '3 000 грн', standard: false, plus: true, premium: true },
    { service: 'Захист від відмов (1 відповідь)', price: '25 000 грн', standard: false, plus: true, premium: true },
    { service: 'Робота зі складними випадками (без ліміту)', price: '25 000 грн', standard: false, plus: false, premium: true },
    { service: 'Апеляційна скарга (за потреби)', price: '30 000 грн', standard: false, plus: false, premium: true },
    { service: 'Гарантія повернення вартості послуг', price: 'Безцінно', standard: false, plus: false, premium: true },
  ],
  'Пост-реєстрація': [
    { service: 'Отримання та відправка свідоцтва', price: '2 000 грн', standard: true, plus: true, premium: true },
    { service: 'Консультація щодо використання ТМ', price: '2 000 грн', standard: false, plus: true, premium: true },
  ]
};

const PACKAGE_PRICES = {
  standard: 7000,
  plus: 14000,
  premium: 25000,
};

const calculateTotal = (key) =>
  Object.values(comparisonData)
    .flat()
    .reduce((acc, item) => {
      if (item[key]) {
        const num = parseInt(item.price.replace(/\D/g, ''), 10);
        return acc + (isNaN(num) ? 0 : num);
      }
      return acc;
    }, 0);

const formatNumber = (num) => `${num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')} грн`;

const CheckIcon = () => (
  <svg width="15" height="11" viewBox="0 0 15 11" fill="none">
    <path d="M13.2902 1.49829L4.87024 9.91829L1.04297 6.09102" stroke="#30D158" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const CrossIcon = () => (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none">
    <path d="M5 16.5L16 5.5" stroke="#FF453A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M16 16.5L5 5.5" stroke="#FF453A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const ComparisonPopup = ({ onClose }) => {
  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.popup} onClick={(e) => e.stopPropagation()}>
        <button className={styles.closeButton} onClick={onClose}></button>
        <h2 className={styles.title}>Порівняння пакетів та їх вигода</h2>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Послуга</th>
              <th>Ринкова ціна</th>
              <th>Standard</th>
              <th>Plus</th>
              <th>Premium</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(comparisonData).map(([category, services]) => (
              <React.Fragment key={category}>
                <tr className={styles.categoryRow}>
                  <td colSpan="5"><CategoryHeader title={category} /></td>
                </tr>
                {services.map((item, index) => (
                  <tr key={index} className={`${index === 0 ? styles.firstServiceItem : ''} ${index === services.length - 1 ? styles.lastServiceItem : ''}`}>
                    <td>{item.service}</td>
                    <td>{item.price}</td>
                    <td>{item.standard ? <CheckIcon /> : <CrossIcon />}</td>
                    <td>{item.plus ? <CheckIcon /> : <CrossIcon />}</td>
                    <td>{item.premium ? <CheckIcon /> : <CrossIcon />}</td>
                  </tr>
                ))}
              </React.Fragment>
            ))}
          </tbody>
          <tfoot>
            <tr className={styles.dividerRow}>
              <td colSpan="5"><div className={styles.divider}></div></td>
            </tr>
            <tr className={styles.summaryRow}>
              <td>Підсумок</td>
              <td></td>
              <td><div className={styles.packageName}>Standard</div></td>
              <td><div className={styles.packageName}>Plus</div></td>
              <td><div className={styles.packageName}>Premium</div></td>
            </tr>
            <tr>
              <td>Загальна цінність</td>
              <td></td>
              <td>{formatNumber(calculateTotal('standard'))}</td>
              <td>{formatNumber(calculateTotal('plus'))}</td>
              <td>{formatNumber(calculateTotal('premium'))}</td>
            </tr>
            <tr>
              <td>Ціна пакета</td>
              <td></td>
              <td>{formatNumber(PACKAGE_PRICES.standard)}</td>
              <td>{formatNumber(PACKAGE_PRICES.plus)}</td>
              <td>{formatNumber(PACKAGE_PRICES.premium)}</td>
            </tr>
            <tr className={styles.benefitRow}>
              <td>Ваша вигода</td>
              <td></td>
              <td>{formatNumber(calculateTotal('standard') - PACKAGE_PRICES.standard)}</td>
              <td>{formatNumber(calculateTotal('plus') - PACKAGE_PRICES.plus)}</td>
              <td>{formatNumber(calculateTotal('premium') - PACKAGE_PRICES.premium)}</td>
            </tr>
          </tfoot>
        </table>
        <button className={styles.understandButton} onClick={onClose}>Зрозуміло</button>
      </div>
    </div>
  );
};

export default ComparisonPopup;
